import { useState, useEffect, useMemo, useCallback } from "react";
import { ModalWrapper, ModalContainer } from "../Dashboard/Dashboard.style";
import DeleteOutlineOutlinedIcon from "@material-ui/icons/DeleteOutlineOutlined";
import DropDown from "../DropDown/DropDown";

import {
  Header,
  CreateAssessmentContainer,
  AssessmentContainer,
  AssessmentContent,
  Dropdown,
  AssessmentButton,
} from "./Modal.style";

import { useAuth } from "../../Auth/Auth";
import QuestionInput from "../Questions/CreateQuestion/QuestionInput";

const OBJECTIVE_TYPES = {
  Mcq: "mcq",
  Mmcq: "mmcq",
  "One Word": "oneword",
  "Fill up": "fillup",
  "Correct Statement": "correctstatement",
};

const COMPETENCY_TYPES = {
  Descriptive: "descriptive",
  "Assertion and Reasoning": "assertion-reasoning",
};

const MAX_OPTIONS = 4;

const CORRECT_STATEMENT_FIELDS = [
  { placeholder: "True", text: "True" },
  { placeholder: "False", text: "False" },
];

const FILL_UP_FIELD = {
  placeholder: "Write Answer",
  text: "",
};

const ASSERTION_REASONING_OPTIONS_HINDI = [
  {
    value:
      "(a) कथन और कारण दोनों सत्य हैं, तथा कारण कथन की सही व्याख्या करता है।",
    optionId: "op1",
  },
  {
    value:
      "(b) कथन और कारण दोनों सत्य हैं, लेकिन कारण कथन की सही व्याख्या नहीं करता है।",
    optionId: "op2",
  },
  {
    value: "(c) कथन सत्य है, लेकिन कारण असत्य है।",
    optionId: "op3",
  },
  {
    value: "(d) कथन और कारण दोनों असत्य हैं।",
    optionId: "op4",
  },
];

const ASSERTION_REASONING_OPTIONS = [
  {
    value:
      "(a) Both assertion and reason are true, and the reason is the correct explanation of the assertion.",
    optionId: "op1",
  },
  {
    value:
      "(b) Both assertion and reason are true, but the reason is not the correct explanation of the assertion.",
    optionId: "op2",
  },
  {
    value: "(c) Assertion is true, but reason is false.",
    optionId: "op3",
  },
  {
    value: "(d) Both assertion and reason are false.",
    optionId: "op4",
  },
];

function Checkbox({ click, checked }) {
  return (
    <div
      onClick={click}
      style={{
        cursor: "pointer",
        height: "15px",
        width: "15px",
        border: "2px solid #5CE0D2",
        backgroundColor: checked ? "#5CE0D2" : "",
      }}
    />
  );
}

function CreateAssessmentComponent({
  setModal,
  handleCreateAssessment,
  no = "1",
  assessmentType = "objective",
}) {
  const { DisplaySnackbar } = useAuth();

  const questionTypes = useMemo(() => {
    return assessmentType === "competency" ? COMPETENCY_TYPES : OBJECTIVE_TYPES;
  }, [assessmentType]);

  const [formData, setFormData] = useState({
    questionType: "",
    cognitive: "",
    difficulty: "",
    language:"English"
  });

  const [question, setQuestion] = useState("");
  const [assertion, setAssertion] = useState("");
  const [reasoning, setReasoning] = useState("");

  const [field, setField] = useState([FILL_UP_FIELD]);

  const [options, setOptions] = useState([{ value: "" }]);

  const [imagesForOptions, setImagesForOptions] = useState([{ value: "" }]);

  const [explanation, setExplanation] = useState("");

  const [correctAnswer, setCorrectAnswer] = useState(-1);

  const [mmcq, setmmcq] = useState([]);

  const [questionImageFile, setQuestionImageFile] = useState(null);

  const [assertionImageFile, setAssertionImageFile] = useState(null);

  const [reasoningImageFile, setReasoningImageFile] = useState(null);

  const [save, setSave] = useState(true);

  const inputDisabled = !formData.questionType;

  useEffect(() => {
    const type = formData.questionType;

    setCorrectAnswer(-1);
    setmmcq([]);

    setQuestionImageFile(null);
    setAssertionImageFile(null);
    setReasoningImageFile(null);

    switch (type) {
      case "Correct Statement":
        setField(CORRECT_STATEMENT_FIELDS);

        setOptions([{ value: "True" }, { value: "False" }]);

        setImagesForOptions([{ value: "" }, { value: "" }]);

        break;

      case "Assertion and Reasoning":
        const OPTIONS = formData.language.toLowerCase() === "english"?ASSERTION_REASONING_OPTIONS:ASSERTION_REASONING_OPTIONS_HINDI
        setField(
          OPTIONS.map((item) => ({
            placeholder: item.value,
            text: item.value,
          })),
        );

        setOptions(
          OPTIONS.map((item) => ({
            value: item.value,
          })),
        );

        setImagesForOptions([
          { value: "" },
          { value: "" },
          { value: "" },
          { value: "" },
        ]);

        break;

      default:
        setField([FILL_UP_FIELD]);

        setOptions([{ value: "" }]);

        setImagesForOptions([{ value: "" }]);

        break;
    }
  }, [formData.questionType, formData.language]);

  const addField = useCallback(() => {
    if (!save) return;

    const type = formData.questionType;

    if (
      [
        "One Word",
        "Descriptive",
        "Correct Statement",
        "Assertion and Reasoning",
      ].includes(type)
    ) {
      return;
    }

    if (["Mcq", "Mmcq"].includes(type) && field.length >= MAX_OPTIONS) {
      return;
    }

    setField((prev) => [...prev, FILL_UP_FIELD]);

    setOptions((prev) => [...prev, { value: "" }]);

    setImagesForOptions((prev) => [...prev, { value: "" }]);
  }, [field.length, formData.questionType, save]);

  const handleDelete = useCallback(
    (idx) => {
      setField((prev) => prev.filter((_, id) => id !== idx));

      setOptions((prev) => prev.filter((_, id) => id !== idx));

      setImagesForOptions((prev) => prev.filter((_, id) => id !== idx));

      if (correctAnswer === idx) {
        setCorrectAnswer(-1);
      }

      setmmcq((prev) =>
        prev
          .filter((item) => item !== idx)
          .map((item) => (item > idx ? item - 1 : item)),
      );
    },
    [correctAnswer],
  );

  const Setmmcqanswer = useCallback((id) => {
    setmmcq((prev) =>
      prev.includes(id) ? prev.filter((item) => item !== id) : [...prev, id],
    );
  }, []);

  const handleQuestionUpload = useCallback(
    (e) => {
      const file = e.target.files?.[0];

      if (!file) return;

      const handlers = {
        question: setQuestionImageFile,
        assertion: setAssertionImageFile,
        reasoning: setReasoningImageFile,
      };

      handlers[e.target.name]?.(file);

      DisplaySnackbar("Image Uploaded", "success");
    },
    [DisplaySnackbar],
  );

  const handleOptionsImage = useCallback(
    (e, idx) => {
      const file = e.target.files?.[0];

      if (!file) return;

      setImagesForOptions((prev) =>
        prev.map((item, id) => (id === idx ? { value: file } : item)),
      );

      DisplaySnackbar("Image Uploaded", "success");
    },
    [DisplaySnackbar],
  );

  const handleOnChange = useCallback((value, idx) => {
    setOptions((prev) =>
      prev.map((item, id) => (idx === id ? { ...item, value } : item)),
    );
  }, []);

  const deleteableField = useMemo(() => {
    if (
      ["One Word", "Descriptive", "Assertion and Reasoning"].includes(
        formData.questionType,
      )
    ) {
      return false;
    }

    return field.length > 1;
  }, [field.length, formData.questionType]);

  const showAddField = useMemo(() => {
    if (
      [
        "One Word",
        "Descriptive",
        "Correct Statement",
        "Assertion and Reasoning",
      ].includes(formData.questionType)
    ) {
      return false;
    }

    if (
      ["Mmcq", "Mcq"].includes(formData.questionType) &&
      field.length >= MAX_OPTIONS
    ) {
      return false;
    }

    return true;
  }, [field.length, formData.questionType]);

  const handleSaveQuestion = async () => {
    if (!save) return;

    const { questionType, cognitive, difficulty } = formData;

    const isLevelMissing =
      assessmentType === "competency" ? !cognitive : !cognitive || !difficulty;

    if (!questionType || isLevelMissing) {
      DisplaySnackbar("Some Fields are empty", "error");
      return;
    }

    if (
      questionType !== "Assertion and Reasoning" &&
      !question &&
      !questionImageFile
    ) {
      DisplaySnackbar("Question is required", "error");
      return;
    }

    if (
      questionType === "Assertion and Reasoning" &&
      !assertion &&
      !reasoning &&
      !assertionImageFile &&
      !reasoningImageFile
    ) {
      DisplaySnackbar("Assertion and Reason are required", "error");
      return;
    }

    const hasEmptyOption = options.some(
      (item, idx) => !item.value && !imagesForOptions[idx]?.value,
    );

    if (hasEmptyOption && !["Assertion and Reasoning"].includes(questionType)) {
      DisplaySnackbar(
        "Either Delete Empty Options or Enter text in it",
        "error",
      );
      return;
    }

    if (
      ["Mcq", "Correct Statement", "Assertion and Reasoning"].includes(
        questionType,
      ) &&
      correctAnswer === -1
    ) {
      DisplaySnackbar("Please Select Atleast One Answer", "error");
      return;
    }

    if (questionType === "Mmcq" && !mmcq.length) {
      DisplaySnackbar("Please Select Atleast One Answer", "error");
      return;
    }

    let crt;

    if (questionType === "Mmcq") {
      crt = mmcq.map((item) => `op${item + 1}`);
    } else if (["Mcq", "Correct Statement"].includes(questionType)) {
      crt = `op${correctAnswer + 1}`;
    } else if (["Fill up", "One Word", "Descriptive"].includes(questionType)) {
      crt = options.map((item, idx) => ({
        blankId: `op${idx + 1}`,
        answer: item.value,
      }));
    } else if (questionType === "Assertion and Reasoning") {
      crt = {
        option: `op${correctAnswer + 1}`,
        explanation,
      };
    }

    const qType = questionTypes[questionType];

    const payload = {
      question,
      assertion,
      reasoning,

      options: options.map((item, idx) => ({
        optionId: `op${idx + 1}`,
        value: item.value,
      })),

      questionType: qType,

      correctAnswers: {
        [qType]: crt,
      },

      marks: "1",

      cognitive: formData.cognitive.toLowerCase(),

      difficulty: formData.difficulty.toLowerCase(),
      language:formData.language.toLowerCase(),

      visibilityStatus: "All",

      quesImg: questionImageFile,

      assertImg: assertionImageFile,

      reasonImg: reasoningImageFile,

      optionsFile: imagesForOptions,
    };

    try {
      setSave(false);

      await handleCreateAssessment(payload);
    } finally {
      setSave(true);
    }
  };

  return (
    <ModalWrapper>
      <ModalContainer
        style={{
          height: "100%",
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <CreateAssessmentContainer
          style={{
            width: "70%",
            height: "90%",
            overflow: "auto",
            margin: "auto auto",
          }}
        >
          <Header>
            <div>
              <h1>Create Assessment</h1>
            </div>

            <div
              style={{
                height: "60px",
                color: "#fff",
                padding: "2px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "space-between",
                width: "60px",
                borderRadius: "50%",
                backgroundColor: "#5CE0D2",
              }}
            >
              <div>Q</div>
              <div>{no}</div>
            </div>
          </Header>

          <div style={{ marginBottom: "10px" }}>
            <span>Courses</span> {` > `}
            <span>India </span> {` > `}
            <span>Boards</span> {` > `}
            <span>Subjects</span> {` > `}
            <span>Chapter</span> {` > `}
            <span>Topics</span>
          </div>

          <AssessmentContainer>
            <AssessmentContent>
              <div className="firstClass">
                {formData.questionType === "Assertion and Reasoning" ? (
                  <>
                    <QuestionInput
                      name="assertion"
                      placeholder="Write Assertion"
                      disabled={inputDisabled}
                      value={assertion}
                      image={assertionImageFile?.name}
                      handleInput={(value) => setAssertion(value)}
                      handleFileUpload={handleQuestionUpload}
                      styles={{ marginBottom: "5px" }}
                      editor={true}
                    />

                    <QuestionInput
                      name="reasoning"
                      placeholder="Write Reason"
                      disabled={inputDisabled}
                      value={reasoning}
                      image={reasoningImageFile?.name}
                      handleInput={(value) => setReasoning(value)}
                      handleFileUpload={handleQuestionUpload}
                      styles={{ marginBottom: "5px" }}
                      editor={true}
                    />
                  </>
                ) : (
                  <QuestionInput
                    name="question"
                    placeholder="Write Question"
                    disabled={inputDisabled}
                    value={question}
                    image={questionImageFile?.name}
                    handleInput={(value) => setQuestion(value)}
                    handleFileUpload={handleQuestionUpload}
                    editor={["Descriptive"].includes(formData.questionType)}
                  />
                )}

                {field.map((item, idx) => (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginTop: "15px",
                    }}
                  >
                    {[
                      "Mcq",
                      "Correct Statement",
                      "Assertion and Reasoning",
                    ].includes(formData.questionType) && (
                      <Checkbox
                        click={() => setCorrectAnswer(idx)}
                        checked={correctAnswer === idx}
                      />
                    )}

                    {formData.questionType === "Mmcq" && (
                      <Checkbox
                        click={() => Setmmcqanswer(idx)}
                        checked={mmcq.includes(idx)}
                      />
                    )}

                    <QuestionInput
                      id={`op${idx + 1}`}
                      name={`op${idx + 1}`}
                      value={options[idx]?.value}
                      image={imagesForOptions[idx]?.value?.name}
                      placeholder={item.placeholder}
                      disabled={inputDisabled}
                      handleInput={(value) => handleOnChange(value, idx)}
                      handleFileUpload={(e) => handleOptionsImage(e, idx)}
                      styles={{
                        flex: "1",
                        margin: "0 5px 0 15px",
                      }}
                      
                    editor={["Descriptive"].includes(formData.questionType)}
                    />

                    {deleteableField ? (
                      <div
                        onClick={() => handleDelete(idx)}
                        style={{
                          cursor: "pointer",
                          margin: "0px",
                          padding: "0px",
                          fontSize: "1.5rem",
                        }}
                      >
                        ×
                      </div>
                    ) : null}
                  </div>
                ))}

                {showAddField && (
                  <div style={{ margin: "16px 0px" }} className="button1">
                    <AssessmentButton onClick={addField} blur>
                      Add Options
                    </AssessmentButton>
                  </div>
                )}

                {formData.questionType === "Assertion and Reasoning" && (
                  <QuestionInput
                    id="op5"
                    name="op5"
                    value={explanation}
                    image={undefined}
                    placeholder="Write Explanation"
                    disabled={inputDisabled}
                    handleInput={(value) => setExplanation(value)}
                    styles={{
                      flex: "1",
                      margin: "15px 5px 0 15px",
                    }}
                    editor={true}
                  />
                )}
              </div>

              <div className="secondClass">
                <Dropdown>
                  <DropDown
                    options={Object.keys(questionTypes)}
                    name="questionType"
                    formData={formData}
                    setFormData={setFormData}
                    placeholder="Choose Question Type"
                  />
                </Dropdown>

                <Dropdown>
                  <DropDown
                    options={[
                      "Knowledge",
                      "Analysis",
                      "Understanding",
                      "Application",
                    ]}
                    name="cognitive"
                    formData={formData}
                    setFormData={setFormData}
                    placeholder="Cognitive"
                  />
                </Dropdown>

                {assessmentType === "objective" ? (
                  <Dropdown>
                    <DropDown
                      options={["Easy", "Intermediate", "Hard"]}
                      name="difficulty"
                      formData={formData}
                      setFormData={setFormData}
                      placeholder="Difficulty"
                    />
                  </Dropdown>
                ):
                (
                  <Dropdown>
                    <DropDown
                      options={["English","Hindi"]}
                      name="language"
                      formData={formData}
                      setFormData={setFormData}
                      placeholder="Difficulty"
                    />
                  </Dropdown>
                )
                }
              </div>
            </AssessmentContent>

            <br />
            <br />

            <div style={{ margin: "16px 0px" }} className="button2">
              <AssessmentButton onClick={handleSaveQuestion}>
                {save ? "Save" : "Please wait Uploading Files ... "}
              </AssessmentButton>

              {save && (
                <AssessmentButton
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                    padding: "0px",
                  }}
                >
                  <DeleteOutlineOutlinedIcon />
                </AssessmentButton>
              )}
            </div>
          </AssessmentContainer>

          <h2
            onClick={() => setModal(false)}
            style={{
              position: "fixed",
              top: "80px",
              right: "120px",
              fontSize: "2rem",
              cursor: "pointer",
              color: "grey",
            }}
          >
            ×
          </h2>
        </CreateAssessmentContainer>
      </ModalContainer>
    </ModalWrapper>
  );
}

export default CreateAssessmentComponent;
